export default "__VITE_ASSET__Bf0Vu4D3__"